<div class="sorteosLoader loader" *ngIf="loading">
  <img src="assets/images/logo-borde-gris.svg" class="brand-shell loader">
</div>



<div class="lottery-container" *ngIf="!loading">
  <img [src]="getBackgroundImageUrl()" alt="image banner" class="img-draw" />

  <div class="banner-text-container" *ngIf="sorteo?.available === false">
    <p>SOLD OUT!</p>
    <p>Se han realizado todos los canjes posibles y se ha agotado el stock de {{sorteo?.name}}.</p>
    <p>¡Nos vemos ahí!</p>

  </div>



  <!-- TEXT EXPIRED-->
  <div class="text-expired" *ngIf="isExpired()">
      <h2>
        El evento ha finalizado
      </h2>
  </div>


  <div class="lottery-text" *ngIf="!isExpired()">
    <div>
      <p>
        {{sorteo.description14}}
        <br />
        Canjeá tus puntos Shell Box por {{ typeValue  !== 'Sorteo' ? pluralValue : 'chances' }}.
      </p>
    </div>
    <div class="steps-card">
      <h2 class="steps-card-title">¿Cómo participo?</h2>

      <div class="steps-card-steps">
        <div class="steps-card-step" *ngFor="let step of steps">
          <span class="steps-card-number">{{ step.number }}.</span>
          <div class="steps-card-text">
            <p>
              {{ step.text }}
            </p>
            <span>{{ step.span }}</span>
          </div>
        </div>
      </div>

      <div class="steps-card-footer">
        <span>Canjeá hasta: {{ this.expirationDate || '' }}</span>
        <span>•</span>
        <span>Recibirás tu {{ typeValue  !== 'Sorteo' ? singularValue : 'chance' }} después del: {{ this.expirationDate || '' }}</span>
      </div>
    </div>
  </div>




  <!-- FORM -->
  <div class="puntos-conversion-container" *ngIf="!isExpired()">
    <div class="info-left">
      <p class="title">Transformá tus<br />puntos en {{ typeValue  !== 'Sorteo' ? pluralValue : 'chances' }}</p>

      <div class="conversion-pill">
        <div class="left">
          <img src="../../../assets/icon/tickets.svg" alt="card icon" />
          <span>1 {{ typeValue  !== 'Sorteo' ? singularValue : 'chance' }}</span>
          <div class="center">
            <img src="../../../assets/icon/equal.svg" alt="equal icon" />
          </div>
        </div>
        <div class="right">
          <span>{{ sorteo.price }} {{ sorteo.price === 1 ? 'Punto' : 'Puntos' }}</span>
        </div>
      </div>


    </div>
    <form [formGroup]="conversorSorteosForm">
      <div class="form-right">
        <p class="form-title">
          Ingresá la cantidad de {{ typeValue  !== 'Sorteo' ? pluralValue : 'chances' }} que querés adquirir
        </p>

        <div *ngIf="errorPuntos" class="alert-error" role="alert">
          <div class="circle-icon">
            <img src="assets/images/circle-alert-sorteo.svg" alt="icon circle alert">
          </div>
          <div class="alert-text">
            <p>{{errorPuntos}}</p>
          </div>
        </div>

        <div class="form-fields">
          <div class="marco{{ conversorSorteosForm.value.inputValue.length > 0 ? '-filled' : '' }}">
            <input id="input" type="number" formControlName="inputValue" maxLength="4" placeholder="{{ typeValue  !== 'Sorteo' ? (pluralValue | titlecase) : 'Chances' }}"
              (input)="handleInputChange($event)" />
              <label class="label-hidden{{ +conversorSorteosForm.value.inputValue > 9 && +conversorSorteosForm.value.inputValue <= 998 ? '-filled' : +conversorSorteosForm.value.inputValue >= 999 ? '-filled-100' : '' }}" *ngIf="conversorSorteosForm.value.inputValue.length > 0">
                {{conversorSorteosForm.value.inputValue == 1 ? (typeValue  !== 'Sorteo' ? (singularValue | titlecase) : 'Chance') : (typeValue  !== 'Sorteo' ? (pluralValue | titlecase) : 'Chances')}}
              </label>
              <div class="custom-number-arrows">
                <div 
                  class="arrow-down"
                  [class.arrow-down-disabled]="limitExceeded"
                  (click)="incrementValue()">
                </div>
                <div 
                  class="arrow-up" 
                  (click)="decrementValue()">
                </div>
              </div>

            </div>
          <span class="arrow">
            <img src="../../../assets/icon/arrow-right.svg" alt="arrow right icon" class="arrow-icon{{ isResponsive ? '-mobile' : '-desktop' }}" />
          </span>
          <p class="puntos"> <b class="{{ chances >= 1 ? 'black' : '' }}">{{ chances * sorteo?.price | number }}</b> Puntos </p>
          <button (click)="handleConversion()"
            class="btn{{ (!conversorSorteosForm.valid || conversionInProgress) ? '-disabled' : '' }}"
            [disabled]="!conversorSorteosForm.valid || conversionInProgress || sorteo?.available === false || conversorSorteosForm.get('inputValue')?.value <= 0">
            Canjear ahora
          </button>
        </div>
        <div class="terms">
          <label>
            <input id="sorteos-acepto-terminos" value="1" formControlName="aceptarTerminos" type="checkbox" />
            He leído y acepto los <a href="#">términos y condiciones</a>
          </label>
          <div class="link">
            <span>Si aún no convertiste tus millas a puntos,</span>
            <a href="/conversor">hacelo acá</a>
          </div>
        </div>
      </div>
    </form>
  </div>


  <!-- MODAL -->
  <div class="main-modal-container" *ngIf="showModal">
    <div class="modal-box">
      <div class="modal-box-header">
        <div class="header">
          <button type="button" (click)="handleModal()">
            <img src="../../../../assets/images/register-asset/close.svg" alt="icon close">
          </button>
          <img src="../../../assets/images/circle-check-register.svg" alt="shell box tilde" />
          <p>¡Felicidades! ya tenés tus {{ typeValue  !== 'Sorteo' ? pluralValue : 'chances' }}</p>
        </div>

        <div class="modal-box-points">
          <div class="container-points">
            <div class="left">
              <div class="left-item">
                <div>
                  <img src="../../../assets/icon/tickets.svg" alt="icono entradas" />
                  <span>{{ chances }} {{ chances === 1 ? (typeValue  !== 'Sorteo' ? singularValue : 'chance') : (typeValue  !== 'Sorteo' ? pluralValue : 'chances') }}</span>
                </div>
                <div class="equal">
                  <img src="../../../assets/icon/equal.svg" alt="icono igual" />
                </div>
              </div>
            </div>

            <div class="right">
              <div class="right-item">
                <img src="../../../assets/icon/coins.svg" alt="icono monedas" />
                <span>{{ chances * sorteo?.price | number }} {{ chances * sorteo?.price === 1 ? 'punto' : 'puntos' }}</span>
              </div>
            </div>
          </div>


          <p>Te enviamos los detalles a tu e-mail</p>
        </div>
      </div>



      <div class="action">
        <p>Podés seguir canjeando puntos para obtener más {{ typeValue  !== 'Sorteo' ? pluralValue : 'chances' }}.</p>
        <button class="enjoy-btn" (click)="handleModal()">
          Seguir canjeando
        </button>
        <hr />
      </div>
    </div>
  </div>